var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"menu-beta-badge"},[_vm._v("Beta")])
}
var staticRenderFns = []

export { render, staticRenderFns }